<template>
  <div class="box">
    <div class="left">
      
      <div class="left-t">
        <el-tabs v-model="chatType" @tab-click="handleClick">

          <el-tab-pane label="求职消息" name="1">
            <div class="left-ts">
              <el-form
                :model="formInline"
                class="demo-form-inline"
              >
                <el-form-item>
                  <el-input
                    v-model="formInline.user"
                    placeholder="请输入联系人名称搜索"
                  >
                  <el-button slot="append" icon="el-icon-search"  @click="onSearch"></el-button>
                </el-input>
                </el-form-item>
              
              </el-form>
            </div>

            <div class="left-b">
              <ul>
                <user-item
                  v-for="(item, index) in jobChatProps.records"
                  @selectItem="selectItem"
                  :key="index"
                  :index="index"
                  :avatar="item.avatar"
                  :name="item.nickname"
                  :time="item.updated_at"
                  :content="item.content"
                  :active="chatType=='1'&&chatIndex==index"
                  :unread="item.unread_num"
                >
                </user-item>

              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane label="好友消息" name="2">
            <div class="left-ts">
              <el-form
                :model="formInline"
                class="demo-form-inline"
              >
                <el-form-item>
                  <el-input
                    v-model="formInline.user"
                    placeholder="请输入联系人名称搜索"
                  >
                  <el-button slot="append" icon="el-icon-search"  @click="onSearch"></el-button>
                </el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="left-b">
              <ul>
                <user-item
                  v-for="(item, index) in friendChatProps.records"
                  @selectItem="selectItem"
                  :key="index"
                  :index="index"
                  :avatar="item.avatar"
                  :name="item.nickname"
                  :time="item.updated_at"
                  :content="item.content"
                  :active="chatType=='2'&&chatIndex==index"
                  :unread="item.unread_num"
                >
                </user-item>
               
              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane label="只看未读" name="3">
            <div class="left-ts">
              <el-form
                :model="formInline"
                class="demo-form-inline"
              >
                <el-form-item>
                  <el-input
                    v-model="formInline.user"
                    placeholder="请输入联系人名称搜索"
                  >
                  <el-button slot="append" icon="el-icon-search"  @click="onSearch"></el-button>

                </el-input>
                </el-form-item>
              
              </el-form>
            </div>
            <div class="left-b">
              <ul>
                <user-item
                  v-for="(item, index) in unreadChatProps.records"
                  @selectItem="selectItem"
                  :key="index"
                  :index="index"
                  :avatar="item.avatar"
                  :name="item.nickname"
                  :time="item.updated_at"
                  :content="item.content"
                  :active="chatType=='3'&&chatIndex==index"
                  :unread="item.unread_num"
                >
                </user-item>
                
              </ul>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- <div class="left-m"></div>
      <div class="left-b"></div> -->
    </div>

    <div v-if="chatItem" class="right">
      <div class="top_1" >
        <div class="topmid">
          <img :src="chatItem.avatar" />
          <div class="wenben">
            <span>{{chatItem.nickname}}</span>
            <b v-if="chatItem.job_type&&chatItem.job_type==2">沟通职位：{{chatItem.title}}</b>
            <b v-if="chatItem.job_type&&chatItem.job_type==2">期待薪资：{{chatItem.wages}}/{{chatItem.unit_str}}</b>

          </div>
        </div>
        <img @click="showInfo" src="@/assets/chat-img/more-set.png" alt="" />
      </div>

      <!--聊天框-->
      <div class="con" id="msgBox">
        <div>
          <!--聊天信息组建-->
          <msg-item  
            v-for="(item,index) in messageList"
            :key="index" 
            :user_avatar="item.user_avatar"
            :receive_avatar="item.receive_avatar"
            :isSend="item.status"
            :type="item.type"
            :lat="item.lat+''"
            :lng="item.lng+''"
            :value_field="item.value_field+''"
            :value_id="item.value_id+''"
            :content="item.content"
            :send_user_id="item.send_user_id+''"
            :receive_user_id="item.receive_user_id+''"
            :type_str="item.type_str"
            :value_public="item.value_public+''"
            > 
          </msg-item>
        </div>
      </div>

      <!--聊天框工具栏-->
      <div class="under">
        <div class="underbox">
          <div class="underbox-l">
            <span>
              <div style="display:flex;align-self:center">
                <Emoji :textAreaId="'msgContent'">
                  <button style="background: transparent;border: unset;">
                    <img src="@/assets/chat-img/bq.png" alt="表情" style="width:25px;height:25px"  /></button>
                </Emoji>
                
              </div>
             
            </span>
            <span>
              <div>
               
              </div>
            </span>  
            <span>
              <quick-reply @quikSend="quikSend">
                  <img src="@/assets/chat-img/infochang.png" alt="" />
                </quick-reply>
              <div @click="sendWeixinPhone(1)" style="margin:0px 10px">
                <img src="@/assets/chat-img/infodianhua.png" alt="电话" />
                <b>电话</b>
              </div>
              <div @click="sendWeixinPhone(2)">
                <img src="@/assets/chat-img/infowechat.png" alt="微信" />
               <b>微信</b>
              </div>
            </span>
          </div>
          <!--
          <div class="underbox-r">
            <b @click="inviteMianshi">邀请面试</b>
            <b @click="inviteRuzhi">邀请入职</b>
            <b @click="inviteContract">签署合同</b>

          </div>-->

          <el-popover
            placement="top-end"
            :tabindex="99"
            width="320"
            trigger="hover">

            <div class="menu-container">
              <div class="menu" @click="inviteMianshi">
                  <img src="@/assets/chat-img/menu-yaoqingmianshi.png"></img>
                  <p>邀请面试</p>
                </div>
                <div class="menu" @click="inviteRuzhi">
                  <img src="@/assets/chat-img/menu-yaoqingruzhi.png"></img>
                  <p>邀请入职</p>
                </div>
              
                <div class="menu" @click="inviteContract">
                  <img src="@/assets/chat-img/menu-qianshuhetong.png"></img>
                  <p>签署合同</p>
                </div>
                <div class="menu" @click="selectPoint">
                  <img src="@/assets/chat-img/menu-dingwei.png"></img>
                  <p>发送位置</p>
                </div>
                <div class="menu" >
                  <el-upload
                      class="upload-demo"
                      :show-file-list="false"
                      :action="uploadFileUrl"
                      :limit="1"
                      :on-error="handleUploadError"
                      :on-exceed="handleExceed"
                      :on-success="(response, file, fileList) =>
                       {return handleUploadFileSuccess(response, file, fileList, 28);}"
                      ref="upload"
                      :auto-upload="true">
                      <div slot="trigger">
                        <img src="@/assets/chat-img/menu-wenjian.png"/>
                        <p>发送文件</p>
                      </div>
                    </el-upload>
                </div>
                <div class="menu" >
                  <el-upload
                      class="upload-demo"
                      :show-file-list="false"
                      :action="uploadFileUrl"
                      :limit="1"
                      :on-error="handleUploadError"
                      :on-exceed="handleExceed"
                      :on-success="(response, file, fileList) =>
                       {return handleUploadFileSuccess(response, file, fileList, 16);}"
                      ref="upload"
                      :auto-upload="true">
                      <div slot="trigger">
                        <img src="@/assets/chat-img/menu-tupian.png"/>
                        <p>发送图片</p>
                      </div>
                    </el-upload>
                </div>
                <div class="menu">
                  <el-upload
                      class="upload-demo"
                      :show-file-list="false"
                      :action="uploadFileUrl"
                      :limit="1"
                      :on-error="handleUploadError"
                      :on-exceed="handleExceed"
                      :on-success="(response, file, fileList) =>
                       {return handleUploadFileSuccess(response, file, fileList, 27);}"
                      ref="upload"
                      :auto-upload="true">
                      <div slot="trigger">
                        <img src="@/assets/chat-img/menu-shipin.png"/>
                        <p>发送视频</p>
                      </div>
                    </el-upload>
                </div>
                <div class="menu" @click="sendRedPack">
                  <img src="@/assets/chat-img/menu-hongbao.png"></img>
                  <p>发送红包</p>
                </div>
            </div>
           
            <el-button slot="reference">更多</el-button>
          </el-popover>
        </div>

        <p>
          <el-input
            id="msgContent"
            type="textarea"
            resize="none"
            rows="5"
            class="msginput"
            placeholder="按下回车键发送消息"
            v-model="content"
            @keyup.enter.native="sendTxtMsg(1)"

          >
          </el-input>
          <el-button type="primary" round @click="sendTxtMsg(1)">发送</el-button>
        </p>
      </div>
    </div>
    <div v-else class="right" style=" justify-content: center; align-items: center;align-self: center;" >
      <el-empty description="暂无聊天消息"></el-empty>
    </div>




    <!--信息面板-->

    <div v-if="chatItem&&appear"  class="boxright1" >
      <div class="boxrightbox">
        <div class="right-t">
          <img :src="chatItem.avatar" alt="" />
          <aside>
            <img src="~@/assets/chat-img/sexwman.png" alt="" />
          </aside>
        </div>

        <div class="right-m">
          <p>{{chatItem.nickname}}</p>
          <span>
            <strong>
              <img src="~@/assets/chat-img/infoxueli.png" alt="" />
              <b>大专</b>
            </strong>
            <strong>
              <img src="~@/assets/chat-img/infonianling.png" alt="" />
              <b>22岁</b>
            </strong>
          </span>
        </div>

        <el-row style="margin-top:50px">
          <el-button type="primary"  size="small">个人主页</el-button>
          <el-button size="small">查看简历</el-button>

        </el-row>
       
      </div>

      <el-row style="margin-top: 20px; text-align: center; margin-bottom: 20px;">
          <el-button type="warning"  size="small">加入黑名单</el-button>
          <el-button type="danger"  size="small">删除聊天</el-button>
        </el-row>

    </div>


    <invite-mianshi-dialog ref="refInviteMianshiDialog" @callback="inviteCallback"></invite-mianshi-dialog>
    <invite-ruzhi-dialog ref="refInviteRuzhiDialog" @callback="inviteCallback"></invite-ruzhi-dialog>
    <invite-contract-dialog ref="refInviteContractDialog" @callback="inviteCallback"></invite-contract-dialog>
    <select-point-dialog ref="mapDialog"  @setAddress="sendAddressPoint"></select-point-dialog>
    <send-redpack-dialog ref="redPackDialogRef"  @callback="sendRedPackMsg"></send-redpack-dialog>

  </div>
</template>

<script>
import Emoji from "@/components/Emoji/Emoji.vue";
import QuickReply from "@/components/chat/quick-reply.vue";
import inviteRuzhiDialog from "@/components/chat/invite-ruzhi-dialog.vue";
import inviteMianshiDialog from "@/components/chat/invite-mianshi-dialog.vue";
import inviteContractDialog from "@/components/chat/invite-contract-dialog.vue";
import selectPointDialog from "@/components/map/select-point-dialog.vue";
import sendRedpackDialog from "@/components/chat/send-redpack-dialog.vue";


import msgItem from "@/components/chat/msg-item.vue";
import userItem from "@/components/chat/user-item.vue";

import { chatList,messagelist,weixinPhone} from "@/api/chat/index";
//import {ws} from '@/utils/ws'     //引用模块进来
import { mapGetters } from 'vuex'
import urlConfig from '@/api/config'

export default {
  components: {
    Emoji,
    QuickReply,
    inviteRuzhiDialog,
    inviteMianshiDialog,
    inviteContractDialog,
    msgItem,
    userItem,
    selectPointDialog,
    sendRedpackDialog
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'isLogin',
      'user_type'// 1 求职 2 招聘
    ]),
  },

  provide(){//在这里对外提供方法，在子孙组件中都可以用这个
    return {
      sendHandleMsg:this.sendMsg
    }
  },

  data() {
    return {
      uploadFileUrl:  urlConfig.prod.baseURL +"/web/file/Upload", // 上传的图片服务器地址

      appear: 0,//个人信息面板
      chatType:"1",//1 求职 2 好友 3 未读
      chatIndex:'-1',
      //好友列表去聊呗是1，客服列表去聊呗是3，其余的全是2
      chatItem:null,

      content:"",//发送的消息内容
      value_field:"",//图片地址，位置信息

      formInline: {
        user: "",
      },

      jobChatProps: {
          records:[],
          total: 0,
          limit: 10,
          page: 1
        },

      friendChatProps: {
          records:[],
          total: 0,
          limit: 10,
          page: 1
        },

      unreadChatProps: {
          records:[],
          total: 0,
          limit: 10,
          page: 1
        },

        messageList:[],
        
    };
  },
  mounted(){
    this.fetchJobChatList();
    this.fetchFriendChatList();
    this.fetchUnreadChatList();
    console.log(this.wsUrl)
  },

  methods: {

    fetchJobChatList(){
      var that = this;
      //type	是	int	1招聘列表2好友列表3未读列表
    //page	否	int	页数
    //limit	否	int	每页条数
    var params={
      page:that.jobChatProps.page,
      limit:that.jobChatProps.limit,
      type:1
    }

      chatList(params).then((response) => {
        that.jobChatProps.records = response.data.data;
        that.jobChatProps.total = response.data.total;
      });
    },


    fetchFriendChatList(){
      var that = this;
      //type	是	int	1招聘列表2好友列表3未读列表
      //page	否	int	页数
      //limit	否	int	每页条数
      var params={
        page:that.friendChatProps.page,
        limit:that.friendChatProps.limit,
        type:2
      }

      chatList(params).then((response) => {
        that.friendChatProps.records = response.data.data;
        that.friendChatProps.total = response.data.total;
      });
    },


    fetchUnreadChatList(){
      var that = this;
      //type	是	int	1招聘列表2好友列表3未读列表
      //page	否	int	页数
      //limit	否	int	每页条数
      var params={
        page:that.unreadChatProps.page,
        limit:that.unreadChatProps.limit,
        type:3
      }

      chatList(params).then((response) => {
        that.unreadChatProps.records = response.data.data;
        that.unreadChatProps.total = response.data.total;
      });
    },

    fetchChatMsgList(receive_id){

      var that = this;
      //type	是	int	1招聘列表2好友列表3未读列表
      //page	否	int	页数
      //limit	否	int	每页条数
      var params={
        "receive_id":receive_id
      }

      messagelist(params).then((response) => {
        if(response.code==200){
           var datas= response.data;
           var receive_avatar=response.receive_avatar;
           var user_avatar=response.user_avatar;
           //
          for (let item of datas) {
            item.receive_avatar=receive_avatar;//
            item.user_avatar=user_avatar;//
          }
          that.messageList=datas;
          this.scrollBottom();
        }
        

      });

    },


    selectItem(index) {
      var that=this;
      that.chatIndex=index;
      var link=2;//好友列表去聊呗是1，客服列表去聊呗是3，其余的全是2 求职
      //1 求职
      if(that.chatType=="1"){
        that.chatItem=that.jobChatProps.records[index];
        that.jobChatProps.records[index].unread_num=0;
      }else if(that.chatType=="2"){
        that.chatItem=that.friendChatProps.records[index];
        that.friendChatProps.records[index].unread_num=0;
        link=1;
      }else if(that.chatType=="3"){
        that.chatItem=that.unreadChatProps.records[index];
        that.unreadChatProps.records[index].unread_num=0;
      }
    
     // ws://81.70.78.15:9502?send_user_id=126&receive_user_id=129&link=2&cus_id=1&job_id=150
      that.ws.initWebSocket(
        that.wsUrl
      +"?send_user_id="+that.chatItem.f_user_app_id
      +"&receive_user_id="+that.chatItem.j_user_app_id
      +"&link="+link+"&job_id="+that.chatItem.job_id);
      if(that.ws.websocket){
        that.ws.websocket.onmessage = function(messageEvent){
          console.log("消息====",messageEvent);
          that.fetchChatMsgList(that.chatItem.j_user_app_id);
        }
      }
      that.fetchChatMsgList(that.chatItem.j_user_app_id);
    },

    handleClick(tab, event) {
      this.chatIndex = "-1";
      
    },

    scrollBottom(){
      this.$nextTick(() => {
        var dom = document.getElementById('msgBox');
        dom.scrollTop = dom.scrollHeight;
     })
    },

    onSearch() {
      console.log("submit!");
    },

    //邀请面试
    inviteMianshi(){
      this.$refs.refInviteMianshiDialog.init(this.chatItem.j_user_app_id);
    },

    //邀请入职
    inviteRuzhi(){
      this.$refs.refInviteRuzhiDialog.init(this.chatItem.j_user_app_id);
    },


    //签署合同
    inviteContract(){
      this.$refs.refInviteContractDialog.init(this.chatItem.j_user_app_id);
    },



    //发送邀请xx消息
    inviteCallback(type,enroll_id){
      this.sendMsg(type,'',enroll_id,'','','','','');
    },
   

    //快捷回复
    quikSend(content){
      this.sendMsg(1,content,'','','','','','');
    },

    selectPoint(){
      this.$refs.mapDialog.init();
    },

    //发送定位
    sendAddressPoint(data){
      console.log(data)
       // sendMsg(type,content='',value_id='',value_field='',lat='',lng='',cus_id='',job_id='') 
       this.sendMsg(17,"",'',data.address,data.lat,data.lng,'','');
      
    },

    sendRedPack(){
      this.$refs.redPackDialogRef.init(this.chatItem.j_user_app_id);
      
    },

    sendRedPackMsg(redpack_id){
      
      this.sendMsg(9,"",redpack_id,'','','','','','');
  },


    sendWeixinPhone(type){
      var that=this;
      weixinPhone({}).then((response) => {
        if(response.code==200){
           var mobile= response.data.mobile;
           var wechat= response.data.wechat;
           if(type==1){//电话
            if(mobile==""||!mobile){
              that.$message.warning("没有绑定手机号");
              return;
            }
            that.sendMsg(1,mobile,'','','','','','');
           }else{
            if(wechat==""||!wechat){
              that.$message.warning("没有设置微信号");
              return;
            }
            that.sendMsg(1,wechat,'','','','','','');
           }
         
        }else{
          that.$message.error(response.msg?response.msg:"获取信息错误");
        }
        

      });
    },

    //发送文本消息
    sendTxtMsg(){
      var msgContent=document.getElementById('msgContent');
      this.content=msgContent.value.trim();
      if(this.content==''|| this.content=="↵"){
          return false;
      }
      console.log(" this.content=", this.content);
      this.sendMsg(1,this.content,'','','','','','','');
    },
   
    //发送消息
    /*
    value_id	是	int	红包id，邀请面试id等
    value_field	是	int	图片地址，位置信息
    lat	是	int	经度
    lng	是	int	纬度
    link	是	int	1好友消息，2求职消息，3客服消息
    cus_id	否	int	客服id
    job_id	否	int	职位id，求职消息时发送
    */
    sendMsg(type,content='',value_id='',value_field='',lat='',lng='',cus_id='',job_id='',value_public='') {
      var link=2;
      if(this.chatType==2){
        link=1;//好友列表去聊呗是1，客服列表去聊呗是3，其余的全是2       1好友消息，2求职消息，3客服消息
      }
     
      if(this.ws.websocket){
        var obj = {
          send_user_id:this.chatItem.f_user_app_id,
          receive_user_id:this.chatItem.j_user_app_id,
          link:link,
          type:type,
          content:type==1?content:'',
          value_id:value_id,
          value_field:value_field,
          lat:lat,
          lng:lng,
          cus_id:cus_id,
          value_public:value_public,
          job_id:this.chatItem.job_id
        }
          var last = JSON.stringify(obj);

          console.log("last",last);
          this.ws.websocket.send(last);

          if(type==1){
            this.content="";
          }

          this.fetchChatMsgList(this.chatItem.j_user_app_id);
        
        }
    },

    showInfo() {
      console.log(this.chatItem);
      if (this.appear == 0) {
        this.appear = 1;
      } else this.appear = 0;
     },





     // 文件个数超出
   handleExceed() {
      this.$message.error(`只允许上传单个文件`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");
    },

  

      // 上传成功回调
     handleUploadFileSuccess(res, file, fileList, type) {
      console.log("handleUploadFileSuccess",res);
      var value_field=res.file;
      var filename=res.filename;
      var value_public=filename;
      this.$message.success("上传成功");
      // sendMsg(type,content='',value_id='',value_field='',lat='',lng='',cus_id='',job_id='') 
      this.sendMsg(type,filename,'',value_field,'','','','',value_public);
    },

    
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
      } else {
        return "";
      }
    },


      
    },
};
</script>

<style lang="scss" scoped>
::v-deep .msginput .el-textarea__inner {
  border: none;
  resize: none;
  background: #fbfbfb;
  
}
.box {
  display: flex;
}
.left {
  width: 316px;
  display: flex;
  height: 648px;
}
.left .left-t {
  width: 316px;
  height: 628px;
  margin-top: 20px;
}
::v-deep .el-tabs__nav-wrap::after {
  width: 0;
}
::v-deep .el-tabs__nav {
  width: 100%;
}
::v-deep .el-tabs__item {
  width: 33%;
  padding: 0;
  text-align: center;
}
::v-deep .el-tabs__active-bar {
  width: 69px !important;
  left: 17px;
}

::v-deep .el-popover__reference-wrapper{
  display: flex;
  align-items: center;
  align-self: center;
  align-content: center;
}
.demo-form-inline {
  width: 90%;
  height: 32px;
  margin: 0 auto;
}
.left-b {
  margin-top: 11px;
}
.left-b ul {
  height: 530px;
  //overflow: scroll;
  overflow-x: hidden;
    overflow-y: scroll;
}

.left-b ul::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 1px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.right {
  // width: 884px;
  flex-grow: 1;
  flex-shrink: 0;
  // background: #f3f3f3;
}
.top_1 {
  height: 72px;
  background-color: #f3f3f3;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.16);
  padding-left: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top_1 img {
  width: 43px;
  height: 43px;
  border-radius: 50%;
  margin-right: 10px;
}
.top_1 .topmid {
  display: flex;
}
.top_1 .topmid .wenben {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top_1 .topmid span {
  font-size: 16px;
  color: #333333;
}
.top_1 .topmid b {
  font-size: 13px;
}
.con {
  // width: 884px;
  height: 418px;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fbfbfb;
}

.under {
  display: flex;
  // width: 659px;
  //height: 158px;
  border-top: 1px solid #cccccc;
  flex-direction: column;
  background: #fbfbfb;
}
.under .underbox {
  padding: 5px 10px 5px 10px;
  display: flex;
  justify-content: space-between;
  //border-bottom: 1px solid #cccccc;
  align-items: center;
}
.under .underbox .underbox-l {
  width: 316px;
  display: flex;
  justify-content: space-around;
}
.under .underbox .underbox-l span {
  /*width: 144px;*/
  display: flex;
  justify-content: space-around;
  div {
    display: flex;
    align-items: center;
    b {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
    }
  }
}
.under .underbox .underbox-r {
  display: flex;
}
.under .underbox .underbox-r b {
  width: 60px;
  margin-left: 32px;
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.under div img {
  width: 30px;
  height: 30px;
}
.under p {
  padding: 10px;
  display: flex;
  align-items: flex-end;
}

.boxright1 {
  width: 320px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.boxrightbox {
  background: #ffffff;
  padding: 26px 21px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.right-t {
  position: relative;
  img {
    width: 66px;
    height: 66px;
    border-radius: 50%;
  }
}

.right-t aside {
  position: absolute;
  top: 40px;
  left: 45px;
  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
}
.right-m {
  flex-direction: column;
  align-items: center;
  display: flex;

  p {
    height: 36px;
    font-size: 19px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    display: flex;
    align-items: flex-end;
  }
  span {
    width: 140px;
    display: flex;
    justify-content: space-around;
  }
  img {
    width: 22px;
    height: 22px;
  }
  strong {
    display: flex;
    align-items: center;
    b {
      font-size: 11px;
    }
  }
}

.menu-container{
  display:flex;
  flex-flow:wrap;
  width:320px;

  .menu{
    width:80px;
    text-align:center;
    margin-bottom:20px;
   

    img{
      width:35px;
      height:35px;
      cursor: pointer;
    }
    p{
      font-size:10px;
      color:#666666;
      cursor: pointer;
    }
  }
}
</style>